import React from 'react';
import LinkRenderer from '../../ui/LinkRenderer';
import { decodeHTML, isHtmlContent } from '../../helpers/decodeHTML';

const BountyDescription = ({
    html,
    descriptionLinkPayload,
    htmlClassName = "prose  text-textPrimary max-w-none [&_p:empty]:before:content-['\\00a0'] [&_p:empty]:inline-block",
    paragraphClassName = "text-textPrimary"
}) => {
    const isHTML = isHtmlContent(decodeHTML(html));
    const htmlString = isHTML ? decodeHTML(html) : html;
    return isHTML ? (
        <div
            className={htmlClassName}
            dangerouslySetInnerHTML={{ __html: htmlString }}
        />
    ) : (
        <LinkRenderer paragraphClass={paragraphClassName} text={htmlString} links={descriptionLinkPayload} />
    );
};

export default BountyDescription;
